/**
 * PC 管理后台侧边栏菜单定义。
 * key 与 sys_menu.perm_key / sys_role_menu.menu_key 保持一致。
 */
export const PC_MENU_GROUPS = [
  {
    title: '基础档案',
    items: [
      { key: 'home', path: '/home', title: '工作台', icon: 'el-icon-s-home' },
      { key: 'home/dashboard-config', path: '/home/dashboard-config', title: '灵活看板', icon: 'el-icon-setting' },
      { key: 'home/hotzone', path: '/home/hotzone', title: '热区信息', icon: 'el-icon-map-location' },
      { key: 'archives/area', path: '/archives/area', title: '项目管理', icon: 'el-icon-office-building' },
      { key: 'archives/grid', path: '/archives/grid', title: '网格管理', icon: 'el-icon-share' },
      { key: 'archives/room', path: '/archives/room', title: '房产信息', icon: 'el-icon-house' },
      { key: 'archives/customer', path: '/archives/customer', title: '客户档案', icon: 'el-icon-user' },
      { key: 'archives/meter', path: '/archives/meter', title: '仪表管理', icon: 'el-icon-odometer' },
      { key: 'archives/recycle', path: '/archives/recycle', title: '房间回收站', icon: 'el-icon-delete' }
    ]
  },
  {
    title: '物业收费',
    items: [
      { key: 'charge/center', path: '/charge/dashboard', title: '收费看板', icon: 'el-icon-data-analysis' },
      { key: 'charge/fee-item', path: '/charge/fee-item', title: '费用定义', icon: 'el-icon-price-tag' },
      { key: 'charge/fee-set', path: '/charge/fee-set', title: '费用分配', icon: 'el-icon-connection' },
      { key: 'charge/meter-reading', path: '/charge/meter-reading', title: '抄表', icon: 'el-icon-discover' },
      { key: 'charge/receivable', path: '/charge/receivable', title: '生成应收', icon: 'el-icon-document' },
      { key: 'charge/temp-receivable', path: '/charge/receivables/temp', title: '生成应收-临时', icon: 'el-icon-edit-outline' },
      { key: 'charge/cashier', path: '/charge/cashier', title: '收银台', icon: 'el-icon-wallet' },
      { key: 'charge/payments', path: '/charge/payments', title: '收款记录', icon: 'el-icon-tickets' },
      { key: 'charge/prepayments', path: '/charge/prepayments', title: '预收款', icon: 'el-icon-coin' },
      { key: 'charge/prepay-offset', path: '/charge/prepayments/offset', title: '批量冲预收款', icon: 'el-icon-sort' },
      { key: 'charge/discounts', path: '/charge/discounts', title: '折扣管理', icon: 'el-icon-price-tag' },
      { key: 'charge/receipts', path: '/charge/receipts', title: '票据管理', icon: 'el-icon-collection-tag' },
      { key: 'charge/invoices', path: '/charge/invoices', title: '换发票', icon: 'el-icon-takeaway-box' },
      { key: 'charge/refunds', path: '/charge/refunds', title: '退费业务', icon: 'el-icon-refresh-left' },
      { key: 'charge/reconciliation', path: '/charge/reconciliation', title: '银行对账', icon: 'el-icon-finished' },
      { key: 'charge/payment-config', path: '/charge/payment-config', title: '支付配置', icon: 'el-icon-setting' }
    ]
  },
  {
    title: '数据报表',
    items: [
      { key: 'report/center', path: '/report/center', title: '报表中心', icon: 'el-icon-data-analysis' }
    ]
  },
  {
    title: '物业活动',
    items: [
      { key: 'community/activity', path: '/community/activity', title: '活动管理', icon: 'el-icon-present' },
      { key: 'community/voucher', path: '/community/voucher', title: '电子凭证活动', icon: 'el-icon-ticket' },
      { key: 'community/gift-redeem', path: '/community/gift-redeem', title: '礼品核销', icon: 'el-icon-s-check' }
    ]
  },
  {
    title: '问卷调查',
    items: [
      { key: 'survey/manage', path: '/survey/manage', title: '问卷管理', icon: 'el-icon-document' },
      { key: 'survey/vote', path: '/survey/vote', title: '投票系统', icon: 'el-icon-s-data' }
    ]
  },
  {
    title: '业主端设置',
    items: [
      { key: 'owner-app/menu', path: '/owner-app/menu', title: '菜单设置', icon: 'el-icon-menu' },
      { key: 'community/activity-stats', path: '/community/activity-stats', title: '活动统计', icon: 'el-icon-data-analysis' }
    ]
  },
  {
    title: '公众号设置',
    items: [
      { key: 'mp/verify', path: '/mp/verify', title: '用户审核', icon: 'el-icon-s-check' },
      { key: 'mp/payment', path: '/mp/payment', title: '交费明细', icon: 'el-icon-wallet' },
      { key: 'mp/posts', path: '/mp/posts', title: '说说管理', icon: 'el-icon-chat-dot-round' },
      { key: 'mp/rooms', path: '/mp/rooms', title: '房间管理', icon: 'el-icon-house' },
      { key: 'mp/buildings', path: '/mp/buildings', title: '楼盘管理', icon: 'el-icon-office-building' },
      { key: 'mp/push', path: '/mp/push', title: '消息推送', icon: 'el-icon-message' },
      { key: 'mp/arrears', path: '/mp/arrears', title: '欠费通知', icon: 'el-icon-bell' },
      { key: 'mp/notice', path: '/mp/notice', title: '业主消息', icon: 'el-icon-s-comment' },
      { key: 'mp/info', path: '/mp/info', title: '公众号信息', icon: 'el-icon-setting' },
      { key: 'mp/deadline', path: '/mp/deadline', title: '截止日期设置', icon: 'el-icon-date' },
      { key: 'mp/owner-audit', path: '/mp/owner-audit', title: '业主审核', icon: 'el-icon-user' }
    ]
  },
  {
    title: '社区运营',
    items: [
      { key: 'community/main', path: '/community/main', title: '社区运营', icon: 'el-icon-star-on' }
    ]
  },
  {
    title: '表单管理',
    items: [
      { key: 'oa/start', path: '/oa/start', title: '发起流程', icon: 'el-icon-plus' },
      { key: 'oa/todo', path: '/oa/todo', title: '待办任务', icon: 'el-icon-s-order' },
      { key: 'oa/process', path: '/oa/process', title: '流程管理', icon: 'el-icon-s-operation' },
      { key: 'oa/template', path: '/oa/template', title: '表单模板', icon: 'el-icon-document' },
      { key: 'oa/type', path: '/oa/type', title: '表单类型', icon: 'el-icon-folder' },
      { key: 'oa/maintain', path: '/oa/maintain', title: '表单维护', icon: 'el-icon-edit-outline' }
    ]
  },
  {
    title: '日报',
    items: [
      { key: 'daily/list', path: '/daily/list', title: '日报列表', icon: 'el-icon-date' }
    ]
  },
  {
    title: '系统管理',
    items: [
      { key: 'system/user', path: '/system/user', title: '人员管理', icon: 'el-icon-user-solid' },
      { key: 'system/role', path: '/system/role', title: '角色管理', icon: 'el-icon-s-check' },
      { key: 'system/dept', path: '/system/dept', title: '部门管理', icon: 'el-icon-s-grid' },
      { key: 'system/post', path: '/system/post', title: '岗位管理', icon: 'el-icon-s-claim' },
      { key: 'system/notice', path: '/system/notice', title: '公告管理', icon: 'el-icon-bell' },
      { key: 'system/menu', path: '/system/menu', title: '菜单管理', icon: 'el-icon-menu' },
      { key: 'system/log', path: '/system/log', title: '日志查看', icon: 'el-icon-document' }
    ]
  },
  {
    title: '物业服务',
    items: [
      { key: 'service/accept', path: '/service/accept', title: '业务受理', icon: 'el-icon-edit-outline' },
      { key: 'service/todo', path: '/service/todo', title: '报事待办工单', icon: 'el-icon-s-claim' },
      { key: 'service/query', path: '/service/query', title: '工单查询', icon: 'el-icon-search' },
      { key: 'service/report', path: '/service/report', title: '工单工时报表', icon: 'el-icon-data-analysis' },
      { key: 'service/grab', path: '/service/grab', title: '抢单配置', icon: 'el-icon-s-flag' },
      { key: 'service/closed', path: '/service/closed', title: '工单完结明细', icon: 'el-icon-folder-checked' },
      { key: 'service/settings', path: '/service/settings', title: '常用设置', icon: 'el-icon-setting' },
      { key: 'service/push', path: '/service/push', title: '工单推送设置', icon: 'el-icon-message' },
      { key: 'service/category', path: '/service/category', title: '报事类目设置', icon: 'el-icon-menu' },
      { key: 'service/work-order', path: '/service/work-order', title: '工单管理', icon: 'el-icon-s-order' },
      { key: 'service/board', path: '/service/board', title: '工单看板', icon: 'el-icon-data-board' },
      { key: 'service/center', path: '/service/center', title: '工单中心', icon: 'el-icon-s-cooperation' },
      { key: 'visitor/list', path: '/visitor/list', title: '访客通行', icon: 'el-icon-user' },
      { key: 'disclosure/list', path: '/disclosure/list', title: '物业公示', icon: 'el-icon-document' },
      { key: 'disclosure/feed', path: '/disclosure/feed', title: '信息上报', icon: 'el-icon-edit-outline' }
    ]
  },
  {
    title: '设备管理',
    items: [
      { key: 'equipment/list', path: '/equipment/list', title: '设备档案', icon: 'el-icon-cpu' },
      { key: 'equipment/work-content', path: '/equipment/work-content', title: '工作内容', icon: 'el-icon-s-order' },
      { key: 'equipment/repair', path: '/equipment/repair', title: '设备报修', icon: 'el-icon-warning-outline' }
    ]
  },
  {
    title: '设备保养',
    items: [
      { key: 'maint/group', path: '/maint/group', title: '保养分组', icon: 'el-icon-user' },
      { key: 'maint/plan', path: '/maint/plan', title: '保养计划', icon: 'el-icon-date' },
      { key: 'maint/task', path: '/maint/task', title: '保养任务', icon: 'el-icon-s-claim' }
    ]
  },
  {
    title: '智能巡检',
    items: [
      { key: 'inspection/board', path: '/inspection/board', title: '巡检看板', icon: 'el-icon-data-board' },
      { key: 'inspection/point', path: '/inspection/point', title: '巡检点位', icon: 'el-icon-location' },
      { key: 'inspection/route', path: '/inspection/route', title: '巡检线路', icon: 'el-icon-share' },
      { key: 'inspection/group', path: '/inspection/group', title: '巡检分组', icon: 'el-icon-s-custom' },
      { key: 'inspection/plan', path: '/inspection/plan', title: '巡检计划', icon: 'el-icon-date' },
      { key: 'inspection/task', path: '/inspection/task', title: '巡检任务', icon: 'el-icon-s-order' },
      { key: 'inspection/report', path: '/inspection/report', title: '巡检报表', icon: 'el-icon-data-analysis' },
      { key: 'inspection/stats', path: '/inspection/stats', title: '执行统计报表', icon: 'el-icon-s-data' }
    ]
  },
  {
    title: '智能巡更',
    items: [
      { key: 'patrol/point', path: '/patrol/point', title: '巡更点位', icon: 'el-icon-location-outline' },
      { key: 'patrol/route', path: '/patrol/route', title: '巡更线路', icon: 'el-icon-share' },
      { key: 'patrol/group', path: '/patrol/group', title: '巡更分组', icon: 'el-icon-s-custom' },
      { key: 'patrol/plan', path: '/patrol/plan', title: '巡更计划', icon: 'el-icon-date' },
      { key: 'patrol/task', path: '/patrol/task', title: '巡更任务', icon: 'el-icon-s-claim' }
    ]
  },
  {
    title: '租赁合同',
    items: [
      { key: 'lease/list', path: '/lease/list', title: '租赁合同列表', icon: 'el-icon-document-copy' },
      { key: 'lease/form', path: '/lease/form', title: '租赁合同添加', icon: 'el-icon-edit-outline' },
      { key: 'lease/rent-map', path: '/lease/rent-map', title: '租控图', icon: 'el-icon-s-grid' },
      { key: 'lease/hotzone', path: '/lease/hotzone', title: '热区图', icon: 'el-icon-map-location' },
      { key: 'lease/report', path: '/lease/report', title: '合同报表', icon: 'el-icon-pie-chart' },
      { key: 'lease/changes', path: '/lease/changes', title: '变更与记录', icon: 'el-icon-notebook-2' },
      { key: 'lease/template', path: '/lease/template', title: '模板管理', icon: 'el-icon-document' }
    ]
  },
  {
    title: '采购管理',
    items: [
      { key: 'purchase/request', path: '/purchase/request', title: '采购申请', icon: 'el-icon-document' },
      { key: 'purchase/plan', path: '/purchase/plan', title: '采购计划', icon: 'el-icon-date' },
      { key: 'purchase/order', path: '/purchase/order', title: '采购订单', icon: 'el-icon-s-order' },
      { key: 'purchase/ledger', path: '/purchase/ledger', title: '采购流水账', icon: 'el-icon-notebook-2' },
      { key: 'purchase/payment', path: '/purchase/payment', title: '付款单', icon: 'el-icon-wallet' }
    ]
  },
  {
    title: '仓库管理',
    items: [
      { key: 'warehouse/basic', path: '/warehouse/basic', title: '基本信息', icon: 'el-icon-notebook-1' },
      { key: 'warehouse/in', path: '/warehouse/in', title: '入库操作', icon: 'el-icon-download' },
      { key: 'warehouse/out', path: '/warehouse/out', title: '出库操作', icon: 'el-icon-upload2' },
      { key: 'warehouse/transfer', path: '/warehouse/transfer', title: '调拨操作', icon: 'el-icon-sort' },
      { key: 'warehouse/damage', path: '/warehouse/damage', title: '报损操作', icon: 'el-icon-warning-outline' },
      { key: 'warehouse/requisition', path: '/warehouse/requisition', title: '领料审批', icon: 'el-icon-s-check' },
      { key: 'warehouse/return-supplier', path: '/warehouse/return-supplier', title: '退货操作', icon: 'el-icon-sell' },
      { key: 'warehouse/return-stock', path: '/warehouse/return-stock', title: '退库操作', icon: 'el-icon-refresh-left' },
      { key: 'warehouse/ticket', path: '/warehouse/ticket', title: '票据管理', icon: 'el-icon-printer' },
      { key: 'warehouse/stock', path: '/warehouse/stock', title: '库存管理', icon: 'el-icon-box' },
      { key: 'warehouse/flow', path: '/warehouse/flow', title: '出入库流水账', icon: 'el-icon-tickets' },
      { key: 'warehouse/report', path: '/warehouse/report', title: '仓库汇总报表', icon: 'el-icon-data-analysis' },
      { key: 'warehouse/split', path: '/warehouse/split', title: '项目分割单', icon: 'el-icon-pie-chart' },
      { key: 'warehouse/exchange', path: '/warehouse/exchange', title: '以旧换新登记', icon: 'el-icon-refresh' }
    ]
  },
  {
    title: '招商CRM',
    items: [
      { key: 'crm/property', path: '/crm/property', title: '房源列表', icon: 'el-icon-office-building' },
      { key: 'crm/team', path: '/crm/team', title: '招商团队', icon: 'el-icon-s-custom' },
      { key: 'crm/agent', path: '/crm/agent', title: '渠道代理', icon: 'el-icon-s-cooperation' },
      { key: 'crm/activity', path: '/crm/activity', title: '市场活动', icon: 'el-icon-present' },
      { key: 'crm/lead', path: '/crm/lead', title: '线索管理', icon: 'el-icon-phone-outline' },
      { key: 'crm/customer', path: '/crm/customer', title: '客户管理', icon: 'el-icon-user' },
      { key: 'crm/opportunity', path: '/crm/opportunity', title: '商机管理', icon: 'el-icon-s-opportunity' },
      { key: 'crm/intention', path: '/crm/intention', title: '意向管理', icon: 'el-icon-star-off' },
      { key: 'crm/competitor', path: '/crm/competitor', title: '竞品市调', icon: 'el-icon-data-analysis' },
      { key: 'crm/visit', path: '/crm/visit', title: '回访管理', icon: 'el-icon-chat-line-round' },
      { key: 'crm/pool-rule', path: '/crm/pool-rule', title: '公海池规则', icon: 'el-icon-share' },
      { key: 'crm/ext-field', path: '/crm/ext-field', title: '扩展字段设置', icon: 'el-icon-setting' },
      { key: 'crm/rating', path: '/crm/rating', title: '商户评级', icon: 'el-icon-medal' },
      { key: 'crm/performance', path: '/crm/performance', title: '员工业绩管理', icon: 'el-icon-s-data' }
    ]
  },
  {
    title: '工作流程',
    items: [
      { key: 'workflow/workspace', path: '/workflow/workspace', title: '工作空间', icon: 'el-icon-s-home' },
      { key: 'workflow/initiated', path: '/workflow/initiated', title: '我发起的', icon: 'el-icon-document' },
      { key: 'workflow/todo', path: '/workflow/todo', title: '待我处理', icon: 'el-icon-s-check' },
      { key: 'workflow/handled', path: '/workflow/handled', title: '已处理的', icon: 'el-icon-finished' },
      { key: 'workflow/cc', path: '/workflow/cc', title: '抄送我的', icon: 'el-icon-message' },
      { key: 'workflow/model', path: '/workflow/model', title: '模型管理', icon: 'el-icon-share' },
      { key: 'workflow/data', path: '/workflow/data', title: '数据管理', icon: 'el-icon-s-data' },
      { key: 'workflow/component', path: '/workflow/component', title: '组件管理', icon: 'el-icon-menu' },
      { key: 'workflow/stats', path: '/workflow/stats', title: '数据统计', icon: 'el-icon-data-analysis' }
    ]
  },
  {
    title: '品质管理',
    items: [
      { key: 'quality/service-item', path: '/quality/service-item', title: '服务项目', icon: 'el-icon-s-grid' },
      { key: 'quality/plan', path: '/quality/plan', title: '品质计划', icon: 'el-icon-date' },
      { key: 'quality/rectify-rate', path: '/quality/rectify-rate', title: '整改合格率', icon: 'el-icon-data-analysis' },
      { key: 'quality/contract', path: '/quality/contract', title: '合同管理', icon: 'el-icon-document' },
      { key: 'quality/daily-check', path: '/quality/daily-check', title: '工作日核', icon: 'el-icon-edit-outline' },
      { key: 'quality/daily-stats', path: '/quality/daily-stats', title: '日核统计', icon: 'el-icon-s-data' },
      { key: 'quality/deduction', path: '/quality/deduction', title: '扣款明细表', icon: 'el-icon-money' },
      { key: 'quality/staff-check', path: '/quality/staff-check', title: '项目成员核查', icon: 'el-icon-user' },
      { key: 'quality/rectify', path: '/quality/rectify', title: '品质整改', icon: 'el-icon-warning-outline' },
      { key: 'quality/query', path: '/quality/query', title: '品质查询', icon: 'el-icon-search' },
      { key: 'quality/verify', path: '/quality/verify', title: '品质复核', icon: 'el-icon-s-check' }
    ]
  },
  {
    title: '凭证管理',
    items: [
      { key: 'finance/interface', path: '/finance/interface', title: '接口参数', icon: 'el-icon-link' },
      { key: 'finance/account-set', path: '/finance/account-set', title: '账套设置', icon: 'el-icon-notebook-2' },
      { key: 'finance/manage-dim', path: '/finance/manage-dim', title: '管理项目', icon: 'el-icon-s-grid' },
      { key: 'finance/subject', path: '/finance/subject', title: '科目配置', icon: 'el-icon-s-operation' },
      { key: 'finance/voucher-gen', path: '/finance/voucher-gen', title: '生成凭证', icon: 'el-icon-document-checked' }
    ]
  },
  {
    title: '发票管理',
    items: [
      { key: 'finance/invoice', path: '/finance/invoice', title: '数电发票', icon: 'el-icon-tickets' },
      { key: 'finance/buyer', path: '/finance/buyer', title: '购买方信息', icon: 'el-icon-user' },
      { key: 'finance/preissue', path: '/finance/preissue', title: '预开收款报表', icon: 'el-icon-data-analysis' }
    ]
  },
  {
    title: '代收代扣',
    items: [
      { key: 'finance/bank-agreement', path: '/finance/bank-agreement', title: '银行托收协议', icon: 'el-icon-s-check' },
      { key: 'finance/bank-scheme', path: '/finance/bank-scheme', title: '银行托收方案', icon: 'el-icon-s-tools' },
      { key: 'finance/bank-collection', path: '/finance/bank-collection', title: '银行托收', icon: 'el-icon-bank-card' },
      { key: 'sms/main', path: '/sms/main', title: '短信设置', icon: 'el-icon-message' }
    ]
  },
  {
    title: '服务合同',
    items: [
      { key: 'finance/svc-overview', path: '/finance/svc-overview', title: '合同概况', icon: 'el-icon-data-board' },
      { key: 'finance/svc-contract', path: '/finance/svc-contract', title: '收支合同', icon: 'el-icon-document' },
      { key: 'finance/svc-expired', path: '/finance/svc-expired', title: '过期合同', icon: 'el-icon-warning-outline' },
      { key: 'finance/company-account', path: '/finance/company-account', title: '银行账户', icon: 'el-icon-coin' },
      { key: 'finance/svc-pay-plan', path: '/finance/svc-pay-plan', title: '回款计划', icon: 'el-icon-date' },
      { key: 'finance/svc-payment', path: '/finance/svc-payment', title: '付款登记审核', icon: 'el-icon-s-finance' },
      { key: 'finance/svc-archive', path: '/finance/svc-archive', title: '合同档案', icon: 'el-icon-folder' }
    ]
  },
  {
    title: '预算管理',
    items: [
      { key: 'finance/budget-template', path: '/finance/budget-template', title: '预算模板', icon: 'el-icon-files' },
      { key: 'finance/budget', path: '/finance/budget', title: '预算编制', icon: 'el-icon-edit-outline' },
      { key: 'finance/budget-detail', path: '/finance/budget-detail', title: '预算明细', icon: 'el-icon-s-data' },
      { key: 'finance/budget-change', path: '/finance/budget-change', title: '预算变更', icon: 'el-icon-refresh' }
    ]
  },
  {
    title: '费用执行',
    items: [
      { key: 'finance/reimburse', path: '/finance/reimburse', title: '报销管理', icon: 'el-icon-wallet' },
      { key: 'finance/loan', path: '/finance/loan', title: '借款管理', icon: 'el-icon-money' },
      { key: 'finance/public-pay', path: '/finance/public-pay', title: '对公请款', icon: 'el-icon-s-order' }
    ]
  },
  {
    title: '人力资源',
    items: [
      { key: 'hr/employee', path: '/hr/employee', title: '员工管理', icon: 'el-icon-s-custom' },
      { key: 'hr/change', path: '/hr/change', title: '变更记录', icon: 'el-icon-refresh' },
      { key: 'hr/resigned', path: '/hr/resigned', title: '离职列表', icon: 'el-icon-user' },
      { key: 'hr/visitor', path: '/hr/visitor', title: '访客记录', icon: 'el-icon-postcard' }
    ]
  },
  {
    title: '考勤管理',
    items: [
      { key: 'hr/clock', path: '/hr/clock', title: '打卡明细', icon: 'el-icon-time' },
      { key: 'hr/daily', path: '/hr/daily', title: '每日统计', icon: 'el-icon-data-analysis' },
      { key: 'hr/shift', path: '/hr/shift', title: '打卡时间表', icon: 'el-icon-date' },
      { key: 'hr/monthly', path: '/hr/monthly', title: '月度汇总', icon: 'el-icon-s-data' },
      { key: 'hr/leave', path: '/hr/leave', title: '请假申请', icon: 'el-icon-document' }
    ]
  },
  {
    title: '个人设置',
    items: [
      { key: 'hr/profile', path: '/hr/profile', title: '个人设置', icon: 'el-icon-setting' }
    ]
  },
  {
    title: '行为分析',
    items: [
      { key: 'hr/behavior', path: '/hr/behavior', title: '行为分析', icon: 'el-icon-view' }
    ]
  },
  {
    title: '人力报表',
    items: [
      { key: 'hr/report', path: '/hr/report', title: '人力报表', icon: 'el-icon-pie-chart' }
    ]
  },
  {
    title: 'AI智能',
    items: [
      { key: 'ai/manage', path: '/ai/manage', title: 'AI管理中心', icon: 'el-icon-s-opportunity' },
      { key: 'ai/center', path: '/ai/center', title: '智能客服', icon: 'el-icon-chat-dot-round' },
      { key: 'ai/knowledge', path: '/ai/knowledge', title: '知识库管理', icon: 'el-icon-notebook-2' },
      { key: 'ai/analytics', path: '/ai/analytics', title: '机器人数据分析', icon: 'el-icon-data-analysis' },
      { key: 'ai/robot', path: '/ai/robot', title: '巡逻机器人', icon: 'el-icon-position' },
      { key: 'ai/maint', path: '/ai/maint', title: '维保预判', icon: 'el-icon-warning-outline' },
      { key: 'ai/alert', path: '/ai/alert', title: '告警中心', icon: 'el-icon-bell' },
      { key: 'ai/sentiment', path: '/ai/sentiment', title: '舆情分析', icon: 'el-icon-s-marketing' },
      { key: 'ai/config', path: '/ai/config', title: 'AI系统配置', icon: 'el-icon-setting' }
    ]
  },
  {
    title: '数据中台',
    items: [
      { key: 'datacenter/overview', path: '/datacenter/overview', title: '集团总览', icon: 'el-icon-s-platform' },
      { key: 'datacenter/project', path: '/datacenter/project', title: '项目主数据', icon: 'el-icon-office-building' },
      { key: 'datacenter/customer', path: '/datacenter/customer', title: '客户主数据', icon: 'el-icon-user' },
      { key: 'datacenter/resource', path: '/datacenter/resource', title: '资源主数据', icon: 'el-icon-house' },
      { key: 'datacenter/supplier', path: '/datacenter/supplier', title: '供方主数据', icon: 'el-icon-s-cooperation' },
      { key: 'datacenter/space', path: '/datacenter/space', title: '空间主数据', icon: 'el-icon-map-location' },
      { key: 'datacenter/employee', path: '/datacenter/employee', title: '员工主数据', icon: 'el-icon-s-custom' },
      { key: 'datacenter/access', path: '/datacenter/access', title: '门禁道闸', icon: 'el-icon-lock' },
      { key: 'datacenter/eba', path: '/datacenter/eba', title: '楼宇自控', icon: 'el-icon-cpu' },
      { key: 'datacenter/call', path: '/datacenter/call', title: '400客服对接', icon: 'el-icon-phone' },
      { key: 'datacenter/api', path: '/datacenter/api', title: 'API管理', icon: 'el-icon-link' },
      { key: 'datacenter/governance', path: '/datacenter/governance', title: '数据治理', icon: 'el-icon-document-checked' },
      { key: 'datacenter/permission', path: '/datacenter/permission', title: '权限体系', icon: 'el-icon-key' },
      { key: 'datacenter/center', path: '/datacenter/center', title: '中台管理', icon: 'el-icon-connection' }
    ]
  },
  {
    title: '决策支撑',
    items: [
      { key: 'bi/center', path: '/bi/center', title: '决策总览', icon: 'el-icon-data-line' },
      { key: 'bi/dashboard', path: '/bi/dashboard', title: '集团驾驶舱', icon: 'el-icon-monitor' },
      { key: 'bi/screen', path: '/bi/screen', title: 'BI大屏', icon: 'el-icon-data-board' },
      { key: 'bi/screen-config', path: '/bi/screen-config', title: '大屏配置', icon: 'el-icon-setting' },
      { key: 'bi/compare', path: '/bi/compare', title: '项目对比', icon: 'el-icon-s-data' },
      { key: 'bi/warning', path: '/bi/warning', title: '风险预警', icon: 'el-icon-warning' },
      { key: 'bi/warning-config', path: '/bi/warning-config', title: '预警配置', icon: 'el-icon-s-tools' },
      { key: 'bi/role-board', path: '/bi/role-board', title: '角色看板', icon: 'el-icon-s-custom' },
      { key: 'bi/report', path: '/bi/report', title: '集团报表', icon: 'el-icon-document' }
    ]
  },
  {
    title: '多经运营',
    items: [
      { key: 'multibiz/main', path: '/multibiz/main', title: '资源运营', icon: 'el-icon-goods' },
      { key: 'multibiz/center', path: '/multibiz/center', title: '多经中心', icon: 'el-icon-s-shop' },
      { key: 'multibiz/parking', path: '/multibiz/parking', title: '车位管理', icon: 'el-icon-truck' },
      { key: 'multibiz/venue', path: '/multibiz/venue', title: '场地运营', icon: 'el-icon-office-building' },
      { key: 'multibiz/ad', path: '/multibiz/ad', title: '广告位管理', icon: 'el-icon-picture-outline' },
      { key: 'multibiz/presale', path: '/multibiz/presale', title: '前介案场', icon: 'el-icon-house' },
      { key: 'multibiz/housekeeping', path: '/multibiz/housekeeping', title: '家政服务', icon: 'el-icon-s-custom' },
      { key: 'multibiz/care', path: '/multibiz/care', title: '养老服务', icon: 'el-icon-first-aid-kit' },
      { key: 'multibiz/locker', path: '/multibiz/locker', title: '快递柜', icon: 'el-icon-takeaway-box' },
      { key: 'multibiz/water', path: '/multibiz/water', title: '桶装水配送', icon: 'el-icon-goods' },
      { key: 'multibiz/proxy', path: '/multibiz/proxy', title: '代缴服务', icon: 'el-icon-tickets' },
      { key: 'multibiz/report', path: '/multibiz/report', title: '综合报表', icon: 'el-icon-data-analysis' }
    ]
  },
  {
    title: '智能水电表',
    items: [
      { key: 'utility/realtime', path: '/utility/realtime', title: '实时走表数', icon: 'el-icon-odometer' },
      { key: 'utility/interval', path: '/utility/interval', title: '区间走表数', icon: 'el-icon-data-line' },
      { key: 'utility/daily', path: '/utility/daily', title: '区间日耗数', icon: 'el-icon-s-data' },
      { key: 'utility/recharge', path: '/utility/recharge', title: '仪表充值', icon: 'el-icon-wallet' },
      { key: 'utility/park', path: '/utility/park', title: '园区数据信息', icon: 'el-icon-office-building' },
      { key: 'utility/reading-e', path: '/utility/reading-e', title: '电表抄表记录', icon: 'el-icon-document' },
      { key: 'utility/reading-w', path: '/utility/reading-w', title: '水表抄表记录', icon: 'el-icon-document' },
      { key: 'utility/finance-e', path: '/utility/finance-e', title: '电表财务报表', icon: 'el-icon-s-finance' },
      { key: 'utility/finance-w', path: '/utility/finance-w', title: '水表财务报表', icon: 'el-icon-s-finance' },
      { key: 'utility/recharge-h', path: '/utility/recharge-h', title: '历史充值记录', icon: 'el-icon-tickets' }
    ]
  },
  {
    title: '增值服务',
    items: [
      { key: 'vas/account', path: '/vas/account', title: '增值服务余额', icon: 'el-icon-coin' },
      { key: 'vas/product', path: '/vas/product', title: '增值服务商品', icon: 'el-icon-goods' },
      { key: 'vas/report', path: '/vas/report', title: '增值服务报表', icon: 'el-icon-pie-chart' },
      { key: 'vas/deposit', path: '/vas/deposit', title: '增值服务押金', icon: 'el-icon-money' },
      { key: 'vas/order', path: '/vas/order', title: '增值服务订单', icon: 'el-icon-s-order' },
      { key: 'vas/verify', path: '/vas/verify', title: '增值服务核销', icon: 'el-icon-s-check' }
    ]
  },
  {
    title: '扩展服务',
    items: [
      { key: 'elder/main', path: '/elder/main', title: '养老服务', icon: 'el-icon-first-aid-kit' },
      { key: 'club/main', path: '/club/main', title: '会所管理', icon: 'el-icon-office-building' },
      { key: 'vehicle/main', path: '/vehicle/main', title: '车辆维修', icon: 'el-icon-truck' },
      { key: 'staff-app/main', path: '/staff-app/main', title: '员工APP功能配置', icon: 'el-icon-mobile-phone' },
      { key: 'call/main', path: '/call/main', title: '呼叫中心', icon: 'el-icon-phone-outline' },
      { key: 'engineering/main', path: '/engineering/main', title: '工程台账', icon: 'el-icon-s-cooperation' },
      { key: 'extension/main', path: '/extension/main', title: '扩展模块', icon: 'el-icon-s-tools' }
    ]
  }
];

/** 扁平化所有菜单 key */
export function allMenuKeys() {
  return PC_MENU_GROUPS.flatMap(g => g.items.map(i => i.key));
}

/** 按角色编码返回默认数据权限 */
export function roleDataScope(code) {
  const map = {
    SUPER_ADMIN: 'ALL',
    PROJECT_MANAGER: 'DEPT',
    FINANCE: 'DEPT',
    ENGINEER_STEWARD: 'SELF',
    STEWARD: 'SELF',
    SECURITY: 'SELF'
  };
  return map[code] || 'SELF';
}

/** 是否集团级（可跨项目） */
export function roleGroupLevel(code) {
  return code === 'SUPER_ADMIN';
}
